import { render, staticRenderFns } from "./activityHeader.vue?vue&type=template&id=65837ac4"
import script from "./activityHeader.vue?vue&type=script&lang=js"
export * from "./activityHeader.vue?vue&type=script&lang=js"
import style0 from "./activityHeader.vue?vue&type=style&index=0&id=65837ac4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports